'use strict';

const React = require('react');

const PropTypes = require('prop-types');

// Stores
const UserStore = require('../../global/stores/UserStore.es');
const PriceStore = require('../../global/stores/PriceStore.es.js');
const ItemStore = require('../../newPdp/stores/ItemStore.es');

// Components
const FormattedPrice = require('../../components/Price/FormattedPrice');
const { Connected: ReducedPrice } = require('../../components/ReducedPrice/ReducedPrice');

// Styles
const priceStyles = require('./pdp-price.scss');
const styles = require('../ReducedPrice/styles.scss');

// Helpers
const provideContext = require('fluxible-addons-react/provideContext');
const connectToStores = require('fluxible-addons-react/connectToStores');
const {pageTypes} = require('dibs-buyer-layout/src/entries/index');
const classnames = require('classnames');

const Price = props => {
    const {
        copy = {},
        context,
        priceDisplays,
        isSold,
        isSoldIndividually,
        isUnlisted,
        currencyLoaded,
        currency,
        retailPrice,
        pageType,
        showTour,
    } = props;
    const { showSalePrice, showNetPrice, showRetailPrice, showPriceUponRequest } = priceDisplays;
    const priceStates = copy.priceStates || {};
    const { sold, unavailable, uponRequest } = priceStates;
    const isPdp = pageType === pageTypes.PAGE_TYPE.PDP;
    const doNotShowFormattedPrice = isSold || isUnlisted || showPriceUponRequest ? true : false;

    const wrapperClasses = classnames('cf', {
        'pdp-price': isPdp,
        [styles.price]: isPdp,
        [priceStyles.portfolio]: pageType === pageTypes.PAGE_TYPE.FAVORITES, // favorites is synonymous to portfolio
    });

    let priceEl;

    if (isSold || isUnlisted) {
        const price = isSold ? sold : unavailable;

        priceEl = (
            <FormattedPrice
                isSoldIndividually={isSoldIndividually}
                copy={copy}
                priceDisplays={priceDisplays}
                doNotShowFormattedPrice={doNotShowFormattedPrice}
                price={price}
                currency={currency}
            />
        );
    } else if (showSalePrice) {
        return <ReducedPrice context={context} pageType={pageType} />;
    } else if (showNetPrice) {
        return <ReducedPrice context={context} showTour={showTour} pageType={pageType} />;
    } else if ((showPriceUponRequest || showRetailPrice) && currencyLoaded) {
        priceEl = (
            <FormattedPrice
                isSoldIndividually={isSoldIndividually}
                copy={copy}
                priceDisplays={priceDisplays}
                doNotShowFormattedPrice={doNotShowFormattedPrice}
                price={showRetailPrice ? retailPrice : uponRequest}
                currency={currency}
                type="retail"
            />
        );
    }

    return (
        <div className={wrapperClasses} data-tn="pdp-price-wrapper">
            <div className="notranslate" data-tn="item-details-price">
                {priceEl}
            </div>
        </div>
    );
};

Price.defaultProps = {
    showTour: false,
};

Price.propTypes = {
    context: PropTypes.object,
    copy: PropTypes.object.isRequired,
    currency: PropTypes.string,
    currencyLoaded: PropTypes.bool,
    isSold: PropTypes.bool.isRequired,
    isUnlisted: PropTypes.bool.isRequired,
    isSoldIndividually: PropTypes.bool.isRequired,
    pageType: PropTypes.string.isRequired,
    price: PropTypes.number,
    priceDisplays: PropTypes.object.isRequired,
    retailPrice: PropTypes.number,
    showTour: PropTypes.bool,
};

const ConnectedPrice = provideContext(
    connectToStores(Price, [ItemStore, PriceStore, UserStore], context => {
        const userStore = context.getStore(UserStore);
        const itemStore = context.getStore(ItemStore);
        const priceStore = context.getStore(PriceStore);
        const item = itemStore.getItem();
        const processedPriceData = priceStore.processPrice(item);
        const { netPriceData = {}, retailPriceData = {}, priceDisplays } = processedPriceData;
        return {
            copy: itemStore.getCopy(),
            currency: userStore.getCurrency(),
            currencyLoaded: userStore.isCurrencyLoaded(),
            isSold: itemStore.getIsSold(),
            isSoldIndividually: itemStore.getSoldIndividually(
                netPriceData.model || retailPriceData.model
            ),
            isUnlisted: itemStore.getIsUnlisted(),
            price: retailPriceData.price || null,
            priceDisplays,
            retailPrice: retailPriceData.price,
        };
    })
);

module.exports = {
    Price: ConnectedPrice,
    Raw: Price,
};



// WEBPACK FOOTER //
// ./assets/js/components/Price/Price.jsx